import { red } from '@kmns-internal/furikake/tokens'
import { TableCell } from '@mui/material'
import { FC, ReactNode } from 'react'
import { bodyCellSx } from './styles'
import { TableSectionRecordedAt } from './TableSectionRecordedAt'

type Props = {
  content: ReactNode
  /** 逸脱（不正値）。背景を薄い赤で強調する。 */
  isInvalid?: boolean
  /** 文字色の上書き（選択肢の設定色など）。 */
  fontColor?: string
  /** 回答日時。 */
  recordedAt?: Date
}

export const TableSectionValueCell: FC<Props> = ({
  content,
  isInvalid,
  fontColor,
  recordedAt,
}) => (
  <TableCell
    sx={{
      ...bodyCellSx,
      ...(isInvalid ? { bgcolor: red[1] } : {}),
    }}
    style={fontColor ? { color: fontColor } : undefined}
  >
    {content}
    <TableSectionRecordedAt recordedAt={recordedAt} />
  </TableCell>
)
